/**
 * @author PengWen
 * @description 岗位兼职信息管理页面配置
 * @Date 2022/11/28
 */
 import React from 'react';
 import {connect} from 'dva';
 import {component_tool, framework_tool, utils_tool} from '@/tool'
 import {Form, message, Popconfirm, Spin, Upload} from "antd";
 import { WizTableForm } from '@/containers/common';
 import RequirementPartTimePositionForm from './requirementPartTimePositionForm';
 const offlineProgramConfig = WizTableForm.Config.offlineProgram(this, { apiParams: { status: 1 } });
 const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1, roleConfig: "teacherRole"} })
 const trainSite = WizTableForm.Config.trainSite()
 let {WizContainer, modelUtils} = framework_tool;
 let {WizCard, WizSelect, WizSwitch, WizForm, WizSpin, WizModal, WizButton, WizIcon, WizDropdown, WizMenu, WizTable, WizRadio, WizDatePicker, WizTooltip } = component_tool;
 let Item = Form.Item;
 let Option = WizSelect.Option;
 let {Session} = utils_tool;
 const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 , organizationNodeCategory:["2"]} })
 const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
 
 class RequirementPartTimePositionDetail extends WizContainer {
 
   componentName = 'RequirementPartTimePositionDetail';
 
   constructor(props) {
     super(props);
     const {history} = props;
     let initialValue = {};
     if (history.location && history.location.pathname === '/dealerNewPersonTrain/requirementPartTimePositionUpd') {
       if (history.location && history.location.record) {
         initialValue = history.location.record;
         Session.set('requirementDetailRecord', initialValue)
       } else {
         initialValue = Session.get('requirementDetailRecord') || {};
       }
     }
     this.state = {
       
     };
     this.initialValue = initialValue;
   }
 
   propsAndStateOnChange = {
     addRequirement: this._addRequirementOver.bind(this),
     updateRequirement: this._updateRequirementOver.bind(this),
   };
 
   /**
    * 将查询到的新开业培训加载到记录中
    */
    _getRequirementInfoOver(nextProps, nextState) {
     let requirementInfo = nextProps.requirementInfo.data;
     const {id} = requirementInfo;
     if (nextProps.requirementInfo.code == 1 && id && id>0) {
       this.initialValue.requirementContents = requirementInfo.requirementContents;
     }else {
       this.initialValue.id = null;
     }
     return true;
   }
 
 
   /**
    * 
    */
   _addRequirementOver(nextProps, nextState) {
     if (nextProps.addRequirement.code == 1) {
       wizNotice.success('保存成功');
       this.jumpPage('replace', '/dealerNewPersonTrain/requirementPartTimePosition');
     } else {
       wizNotice.error('提交失败：' + nextProps.addRequirement.msg);
     }
     return true;
   }
 
   _updateRequirementOver(nextProps, nextState) {
     if (nextProps.updateRequirement.code == 1) {
       wizNotice.success('保存成功');
       this.jumpPage('replace', '/dealerNewPersonTrain/requirementPartTimePosition');
     } else {
       wizNotice.error('提交失败：' + nextProps.updateRequirement.msg);
     }
     return true;
   }
 
   /**
    * 过滤字段值为undefined&null的字段
    * @param fieldsValue
    */
   fitterFieldsValue(fieldsValue) {
     let fitterValues = fieldsValue;
     let stage = {};
     let cert = {};
     let offlineProgram = {};
     let personnelAssessment = {};
 
     let resume = {};
     let mbti = {};
     let interview = {};
     let electricCert = {};
     let positionAuth = {};
 
     let exam = {};
 
     let requirementContentCmds = [];
     Object.keys(fieldsValue).forEach(key => {
       const value = fieldsValue[key];
       if(key === 'stageId'){
         stage.entityId = value;
         stage.type = 0 ;
       }
       if(key === 'modes'){
         stage.modes = value;
       }
       if (key === 'certId'){
         cert.type = 1 ;
         cert.entityId = value;
       }
       if (key === 'offlineProgramId'){
         offlineProgram.type = 2 ;
         offlineProgram.entityId = value;
       }
       if (key === 'type' && value && value.indexOf(3)!=-1){
         personnelAssessment.type = 3;
         personnelAssessment.entityId=-1;
       }
       if (key === 'type' && value && value.indexOf(5)!=-1){
         resume.type = 5;
         resume.entityId=-1;
       }
       if (key === 'type' && value && value.indexOf(6)!=-1){
         mbti.type = 6;
         mbti.entityId=-1;
       }
       if (key === 'type' && value && value.indexOf(7)!=-1){
         interview.type = 7;
         interview.entityId=-1;
       }
       if (key === 'type' && value && value.indexOf(8)!=-1){
         electricCert.type = 8;
         electricCert.entityId=-1;
       }
       if (key === 'type' && value && value.indexOf(9)!=-1){
         positionAuth.type = 9;
         positionAuth.entityId=-1;
       }
       if (key === 'examId'){
         exam.type = 10 ;
         exam.entityId = value;
       }
       
     });
     if(cert.entityId){
       requirementContentCmds.push(cert);
     }
     if(stage.entityId){
       requirementContentCmds.push(stage);
     }
     if(offlineProgram.entityId){
       requirementContentCmds.push(offlineProgram);
     }
     if(personnelAssessment.entityId == -1){
       requirementContentCmds.push(personnelAssessment);
     }
     if(resume.entityId == -1){
       requirementContentCmds.push(resume);
     }
     if(mbti.entityId == -1){
       requirementContentCmds.push(mbti);
     }
     if(interview.entityId == -1){
       requirementContentCmds.push(interview);
     }
     if(electricCert.entityId == -1){
       requirementContentCmds.push(electricCert);
     }
 
     if(positionAuth.entityId == -1){
       requirementContentCmds.push(positionAuth);
     }
 
     if(exam.entityId){
       requirementContentCmds.push(exam);
     }
 
     fitterValues.requirementContentCmds = requirementContentCmds;
     if(this.initialValue.id){
       fitterValues.id = this.initialValue.id;
     }
     return fitterValues;
   };
 
   /**
    * 保存/更新 
    * @param values
    * @private
    */
   _saveRequirement(values) {
     const {history} = this.props;
     let apiPath = "RequirementPartTimePosition/add";
     let payloadKey = "RequirementPartTimePosition@add";
     if (history.location && history.location.pathname === '/dealerNewPersonTrain/requirementPartTimePositionUpd') {
       apiPath = "RequirementPartTimePosition/update";
       payloadKey = "RequirementPartTimePosition@update";
     }
     let fitterValues = this.fitterFieldsValue(values);
     this.doAction({
       path: apiPath,
       payload: {
         key: payloadKey,
         apiParams: {
           ...fitterValues
         }
       }
     });
   };
 
   
 
   _render() {
        return (
          <>
            <WizCard>
            <WizSpin tip={"加载中"} spinning={this.props.requirementLoading }>
                        <RequirementPartTimePositionForm key = {this.state.ruleId} submit={(v) => { this._saveRequirement(v) }} data={this.initialValue}/>
                    </WizSpin>
            </WizCard>
          </>
        );
      }
 }
 
 const mapStateToProps = (state, ownProps) => {
   const {RequirementPartTimePosition} = state;
   const addRequirement = modelUtils.getModelEntity(RequirementPartTimePosition, "RequirementPartTimePosition@add");
   console.log('aaaa',addRequirement);
   const updateRequirement = modelUtils.getModelEntity(RequirementPartTimePosition, "RequirementPartTimePosition@update");
   const load = modelUtils.getLoadingState(state, ['requirement']);
   return {
     addRequirement: addRequirement,
     updateRequirement: updateRequirement,
     ...load
   }
 };
 
 export default connect(mapStateToProps)(RequirementPartTimePositionDetail);
 